/* AUREAH theme behaviour — sticky nav, reveal-on-scroll, drawers, cart AJAX, PDP/product-card interactions */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---- sticky nav: glassy + compact once scrolled ---- */
  function initNav() {
    var nav = document.querySelector('[data-nav]');
    if (!nav) return;
    var ticking = false;
    function sync() {
      if (window.pageYOffset > 28) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(sync); ticking = true; }
    }, { passive: true });
    sync();
  }

  /* ---- pre-order countdown(s): any [data-countdown] with data-deadline (ISO) ----
     Admin-controlled per product via custom.preorder_deadline (PRD.md §5.2) — a
     generalized, optional replacement for the old theme's single hardcoded
     weekly-drop countdown. When the deadline has passed, the element is simply
     hidden rather than showing a stale/negative countdown; nothing about the
     product itself is affected. */
  function initCountdowns() {
    var els = [].slice.call(document.querySelectorAll('[data-countdown][data-deadline]'));
    if (!els.length) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function set(el, unit, val) {
      var t = el.querySelector('[data-unit="' + unit + '"]');
      if (t) t.textContent = val;
    }
    function tick() {
      var now = Date.now();
      els.forEach(function (el) {
        var end = new Date(el.getAttribute('data-deadline')).getTime();
        if (isNaN(end)) { el.hidden = true; return; }
        var diff = end - now;
        if (diff <= 0) { el.hidden = true; return; }
        el.hidden = false;
        var d = Math.floor(diff / 864e5),
            h = Math.floor(diff % 864e5 / 36e5),
            m = Math.floor(diff % 36e5 / 6e4),
            s = Math.floor(diff % 6e4 / 1e3);
        set(el, 'd', d); set(el, 'h', pad(h)); set(el, 'm', pad(m)); set(el, 's', pad(s));
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- reveal on scroll (progressive enhancement) ---- */
  function initReveal() {
    var items = [].slice.call(document.querySelectorAll('.rise'));
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduce) { return; } /* stays visible */
    document.documentElement.classList.add('js-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ============================================================
     DRAWERS — generic open/close for nav / filters / cart / quick-add
     ============================================================ */
  var openDrawer = null;

  function getDrawer(id) { return document.getElementById(id); }

  function openDrawerById(id, opener) {
    var drawer = getDrawer(id);
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) closeDrawerEl(openDrawer);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer._opener = opener || null;
    openDrawer = drawer;
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeDrawerEl(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (drawer === openDrawer) {
      openDrawer = null;
      document.documentElement.style.overflow = '';
    }
    if (drawer._opener && typeof drawer._opener.focus === 'function') drawer._opener.focus({ preventScroll: true });
  }

  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        openDrawerById(opener.getAttribute('data-drawer-open'), opener);
        return;
      }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) {
        e.preventDefault();
        closeDrawerEl(closer.closest('.drawer'));
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openDrawer) closeDrawerEl(openDrawer);
    });
  }

  /* ============================================================
     PRODUCT CARD — thumbnail -> video hover swap
     ============================================================ */
  function initProductCardVideo() {
    var cards = [].slice.call(document.querySelectorAll('[data-product-card]'));
    cards.forEach(function (card) {
      var media = card.querySelector('.product-card__media');
      var video = card.querySelector('.product-card__video');
      if (!media || !video) return;
      var play = function () {
        media.classList.add('is-playing');
        video.play && video.play().catch(function () {});
      };
      var stop = function () {
        media.classList.remove('is-playing');
        video.pause && video.pause();
        try { video.currentTime = 0; } catch (err) {}
      };
      card.addEventListener('mouseenter', play);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', play);
      card.addEventListener('focusout', stop);
    });
  }

  /* ============================================================
     ACCORDION (PDP description / shipping)
     ============================================================ */
  function initAccordion() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.accordion__trigger');
      if (!trigger) return;
      var item = trigger.closest('.accordion__item');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.accordion__item.is-open').forEach(function (open) {
        if (open !== item) open.classList.remove('is-open');
      });
      item.classList.toggle('is-open', !wasOpen);
      trigger.setAttribute('aria-expanded', String(!wasOpen));
    });
  }

  /* ============================================================
     PDP GALLERY — next-arrow cycle
     ============================================================ */
  function initShipBar() {
    var bars = [].slice.call(document.querySelectorAll('[data-ship-bar]'));
    if (!bars.length) return;
    function fmt(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }
    function update(total) {
      bars.forEach(function (bar) {
        var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 299900;
        var msg = bar.querySelector('[data-ship-msg]');
        var fill = bar.querySelector('[data-ship-fill]');
        var pct = Math.min(100, Math.round(total / threshold * 100));
        if (fill) fill.style.width = pct + '%';
        if (msg) msg.innerHTML = total >= threshold
          ? '🎉 You’ve unlocked <strong>free shipping</strong>!'
          : 'You’re <strong>' + fmt(threshold - total) + '</strong> away from <strong>free shipping</strong>';
      });
    }
    function refresh() { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { update(c.total_price); }).catch(function () {}); }
    refresh();
    ['[data-cart-items]', '[data-cart-subtotal]'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) new MutationObserver(refresh).observe(el, { childList: true, subtree: true, characterData: true });
    });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-sticky-add],[data-product-form] [type=submit]')) setTimeout(refresh, 700); });
  }

  function initStickyAtc() {
    var sticky = document.querySelector('[data-pdp-sticky]');
    var form = document.querySelector('[data-product-form]');
    if (!sticky || !form) return;
    var addBtn = sticky.querySelector('[data-sticky-add]');
    if (addBtn) addBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else { var s = form.querySelector('[type=submit]'); if (s) s.click(); }
    });
    var anchor = form.querySelector('[type=submit]') || form;
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.hidden = en.isIntersecting; document.body.classList.toggle('has-sticky-atc', !en.isIntersecting); });
    }, { rootMargin: '0px 0px -15% 0px' }).observe(anchor);
  }

  function initNewsletterPopup() {
    var pop = document.querySelector('[data-newsletter-popup]');
    if (!pop) return;
    var KEY = 'aureah_np';
    function suppressed() { try { var t = parseInt(localStorage.getItem(KEY), 10); return t && (Date.now() - t) < 14 * 864e5; } catch (e) { return false; } }
    function suppress() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    function open() { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add('is-open'); }); }
    function close() { pop.classList.remove('is-open'); suppress(); setTimeout(function () { pop.hidden = true; }, 300); }
    [].slice.call(pop.querySelectorAll('[data-np-close]')).forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    if (pop.hasAttribute('data-force-open')) { open(); suppress(); return; }
    if (suppressed()) return;
    var shown = false;
    function trigger() { if (shown || suppressed()) return; shown = true; open(); }
    setTimeout(trigger, 8000);
    document.addEventListener('mouseout', function (e) { if (e.clientY <= 0 && !e.relatedTarget) trigger(); });
  }

  function initCopyCode() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-copy-code]');
      if (!el) return;
      var code = el.getAttribute('data-copy-code');
      if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
      el.classList.add('is-copied');
      var sp = el.querySelector('span'); if (sp) sp.textContent = 'copied!';
    });
  }

  /* Hero-product carousel. Unlike initHeroSlideshow, which re-writes shared text
     nodes, each piece here owns its price, comfort badges and stock line, so a
     whole slide is swapped. Slides start display:none, which means the reveal
     IntersectionObserver never fires for them — so `.rise` is settled by hand on
     activation, otherwise slide two would fade in at opacity 0 and stay there. */
  function initHeroProduct() {
    document.querySelectorAll('[data-heroprod]').forEach(function (hero) {
      var slides = [].slice.call(hero.querySelectorAll('[data-heroprod-slide]'));
      if (slides.length < 2) return;
      var interval = parseInt(hero.getAttribute('data-heroprod-interval'), 10) || 7000;
      var dots = [].slice.call(hero.querySelectorAll('[data-heroprod-dot]'));
      var i = 0, timer = null;
      function settle(slide) {
        slide.querySelectorAll('.rise').forEach(function (el) { el.classList.add('is-in'); });
      }
      function go(n) {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        settle(slides[i]);
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      function start() { if (timer) return; timer = setInterval(function () { if (!document.hidden) go(i + 1); }, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function bump(n) { go(n); stop(); start(); }
      dots.forEach(function (d) {
        d.addEventListener('click', function () { bump(parseInt(d.getAttribute('data-heroprod-dot'), 10) || 0); });
      });
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) bump(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      start();
    });
  }

  function initHeroSlideshow() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(function (hero) {
      var slides = [].slice.call(hero.querySelectorAll('.hero__slide'));
      if (!slides.length) return;
      var interval = parseInt(hero.getAttribute('data-hero-interval'), 10) || 6000;
      var eyebrowEl = hero.querySelector('[data-hero-eyebrow]');
      var captionEl = hero.querySelector('[data-hero-caption]');
      var ctaEl = hero.querySelector('[data-hero-cta]');
      var badgeEl = hero.querySelector('[data-hero-badge]');
      var dots = [].slice.call(hero.querySelectorAll('[data-hero-dot]'));
      var prev = hero.querySelector('[data-hero-prev]');
      var next = hero.querySelector('[data-hero-next]');
      var i = 0, timer = null;
      function fadeSet(el, val, extra) {
        if (!el) return;
        el.classList.add('is-fading');
        setTimeout(function () { el.textContent = val; if (extra) extra(); el.classList.remove('is-fading'); }, 300);
      }
      function sync() {
        var s = slides[i];
        fadeSet(eyebrowEl, s.getAttribute('data-eyebrow') || '');
        fadeSet(captionEl, s.getAttribute('data-caption') || '');
        if (ctaEl) fadeSet(ctaEl, s.getAttribute('data-cta') || 'Shop', function () { ctaEl.setAttribute('href', s.getAttribute('href')); });
        if (badgeEl) {
          var b = (s.getAttribute('data-badge') || '').trim();
          fadeSet(badgeEl, b, function () { badgeEl.classList.toggle('is-hidden', !b); });
        }
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      function go(n) { slides[i].classList.remove('is-active'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-active'); sync(); }
      function start() { if (slides.length < 2 || timer) return; timer = setInterval(function () { if (!document.hidden) go(i + 1); }, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function bump(n) { go(n); stop(); start(); }
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); bump(i + 1); });
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); bump(i - 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { bump(parseInt(d.getAttribute('data-hero-dot'), 10) || 0); }); });
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) bump(dx < 0 ? i + 1 : i - 1); x0 = null; }, { passive: true });
      // Autoplay runs continuously (only paused while the tab is hidden) — no hover pause,
      // so it always advances on load without needing a manual interaction first.
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      start();
    });
  }

  function initTileCarousels() {
    document.querySelectorAll('[data-tile-carousel]').forEach(function (tile) {
      var slides = [].slice.call(tile.querySelectorAll('.cat-tile__slide'));
      if (slides.length < 2) return;
      var dots = [].slice.call(tile.querySelectorAll('[data-tile-dot]'));
      var delay = parseInt(tile.getAttribute('data-tile-autoplay'), 10) || 3500;
      var i = 0, paused = false;
      function show(n) {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) dots[i].classList.add('is-active');
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          show(parseInt(dot.getAttribute('data-tile-dot'), 10) || 0);
        });
      });
      tile.addEventListener('mouseenter', function () { paused = true; });
      tile.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden || tile.offsetParent === null) return;
        show(i + 1);
      }, delay);
    });
  }


  // STYLE ME — chip picker that composes a WhatsApp message from her choices.
  // WhatsApp is the primary CTA because that's where this brand actually sells;
  // the Shopify contact form underneath is the fallback, and both are fed from
  // the same composed text so a lead reads identically either way.
  function initStyleMe() {
    document.querySelectorAll('[data-style-me]').forEach(function (root) {
      var groups   = [].slice.call(root.querySelectorAll('[data-sm-group]'));
      var preview  = root.querySelector('[data-sm-preview]');
      var send     = root.querySelector('[data-sm-send]');
      var note     = root.querySelector('[data-sm-note]');
      var emailBtn = root.querySelector('[data-sm-email]');
      var emailForm= root.querySelector('[data-sm-emailform]');
      var bodyField= root.querySelector('[data-sm-body]');
      var wa       = root.getAttribute('data-wa') || '';
      var picked   = {};

      function compose() {
        var parts = [];
        if (picked.occasion) parts.push(picked.occasion.join(', '));
        if (picked.budget)   parts.push('budget ' + picked.budget.join(', '));
        if (picked.size)     parts.push('size ' + picked.size.join(', '));
        if (picked.vibe)     parts.push(picked.vibe.join(' + '));
        var line = parts.join(' · ');
        var extra = note && note.value.trim();
        var msg = 'Hi AUREAH! Style me please.';
        if (line)  msg += '\n\n' + line;
        if (extra) msg += '\n\n' + extra;
        return { line: line, msg: msg };
      }

      // ---- catalogue + matching -------------------------------------------
      var catalogEl = document.querySelector('[data-styleme-catalog]');
      var catalog = [];
      if (catalogEl) { try { catalog = JSON.parse(catalogEl.textContent) || []; } catch (e) { catalog = []; } }

      var results     = root.querySelector('[data-sm-results]');
      var resultsGrid = root.querySelector('[data-sm-results-grid]');
      var resultsSub  = root.querySelector('[data-sm-results-sub]');

      // Chip label -> the occasion tag used on products.
      var OCC = {
        'Everyday': 'everyday', 'Work / 9-to-5': 'work', 'Day out': 'day-out',
        'Brunch': 'brunch-date', 'Date night': 'date-night',
        'Festive / wedding': 'festive', 'Sleepover / lounge': 'sleepover'
      };
      // Budget ceiling for the WHOLE look, not per piece.
      var CAP = {
        'Under ₹1,000': 1000, '₹1,000 – ₹2,500': 2500,
        '₹2,500 – ₹5,000': 5000, '₹5,000+': 1e9, 'Flexible': 1e9
      };
      // Vibe -> collections and feature tags that genuinely carry that feeling.
      var VIBE = {
        'Elegant':         { coll: ['festive-collection','ceo-edits','soft-muse','work'], feat: ['lined'] },
        'Baddie':          { coll: ['baddies-box','teekha-collection','zip-slay'],        feat: ['no-bra'] },
        'Soft & romantic': { coll: ['soft-muse','brunch-date'],                            feat: ['lined'] },
        'Minimal':         { coll: ['ceo-edits','9-to-5-edits'],                           feat: [] },
        'Bold / statement':{ coll: ['baddies-box','zip-slay','teekha-collection'],         feat: [] },
        'Comfort first':   { coll: ['sleepover','everyday'],                               feat: ['free-size','all-day-denim','no-bra'] }
      };

      // The catalogue runs TWO sizing systems: tops use XS-XXL, bottoms use waist
      // numbers (28/30/32) or "Free Size". Filtering everything by one letter size
      // silently removed every bottom and made pairing impossible, so only apply
      // the filter to products that actually speak the same vocabulary.
      var LETTERS = ['XS','S','M','L','XL','XXL'];
      function usesLetterSizes(p) {
        return (p.sizes || []).some(function (x) { return LETTERS.indexOf(x) > -1; });
      }
      function fitsSize(p) {
        var want = picked.size && picked.size[0];
        if (!want || want.indexOf('Not sure') === 0) return true;
        if (!p.sizes || !p.sizes.length) return true;
        if (!usesLetterSizes(p)) return true;          // waist / free size — not comparable
        return p.sizes.indexOf(want) > -1;
      }
      function vibeScore(p) {
        var vs = picked.vibe || [];
        if (!vs.length) return 0;
        var score = 0;
        vs.forEach(function (v) {
          var m = VIBE[v]; if (!m) return;
          m.coll.forEach(function (c) { if (p.coll.indexOf(c) > -1) score += 2; });
          m.feat.forEach(function (f) { if (p.feat.indexOf(f) > -1) score += 1; });
        });
        return score;
      }
      function occScore(p, occ) { return occ && p.occ.indexOf(occ) > -1 ? 3 : 0; }

      function recommend() {
        if (!results) return;
        var occ = picked.occasion ? OCC[picked.occasion[0]] : null;
        if (!occ) { results.hidden = true; return; }
        var cap = picked.budget ? (CAP[picked.budget[0]] || 1e9) : 1e9;

        var pool = catalog.filter(fitsSize);
        var rank = function (p) { return occScore(p, occ) + vibeScore(p) - (p.p / 100000); };

        var byRank = function (a, b) { return rank(b) - rank(a); };
        var allSets = pool.filter(function (p) { return p.role === 'set' && p.p <= cap; }).sort(byRank);
        var onOcc   = allSets.filter(function (p) { return p.occ.indexOf(occ) > -1; });
        var offOcc  = allSets.filter(function (p) { return p.occ.indexOf(occ) < 0; });
        var tops = pool.filter(function (p) { return p.role === 'top'; }).sort(byRank);
        var bots = pool.filter(function (p) { return p.role === 'bottom'; }).sort(byRank);

        var looks = [];
        // Look 1: the best set that genuinely matches the occasion.
        if (onOcc.length) looks.push({ kind: 'The whole look, one piece', items: [onOcc[0]] });

        // Look 2-3: top + bottom pairs under the combined budget. Variety matters
        // more than squeezing out the single highest score, so each piece is used once.
        var usedTop = {}, usedBot = {};
        for (var i = 0; i < tops.length && looks.length < 3; i++) {
          if (usedTop[tops[i].h]) continue;
          for (var j = 0; j < bots.length; j++) {
            if (usedBot[bots[j].h]) continue;
            if (tops[i].p + bots[j].p > cap) continue;
            usedTop[tops[i].h] = usedBot[bots[j].h] = 1;
            looks.push({ kind: 'Put together for you', items: [tops[i], bots[j]] });
            break;
          }
        }
        // Then more occasion-matching sets, and only last anything merely close —
        // labelled honestly so a work outfit never poses as a festive one.
        for (var k = 1; k < onOcc.length && looks.length < 3; k++) {
          looks.push({ kind: 'Another for the same night', items: [onOcc[k]] });
        }
        for (var m = 0; m < offOcc.length && looks.length < 3; m++) {
          looks.push({ kind: 'Close, from another edit', items: [offOcc[m]] });
        }

        if (!looks.length) {
          // Say which constraint is actually blocking rather than dead-ending.
          // "Nothing matches" is unhelpful when the sleepover sets are in budget
          // and in stock, and only the size ruled them out.
          var occPool  = catalog.filter(function (p) { return p.occ.indexOf(occ) > -1; });
          var inBudget = occPool.filter(function (p) { return p.p <= cap; });
          var inSize   = inBudget.filter(fitsSize);
          var msg, sizes = [];
          if (!occPool.length) {
            msg = 'Nothing is tagged for that occasion yet — ask us and we will put something together.';
          } else if (!inBudget.length) {
            var cheapest = Math.min.apply(null, occPool.map(function (p) { return p.p; }));
            msg = 'Nothing for that occasion comes in under that budget — the lowest is ₹' +
                  Math.round(cheapest).toLocaleString('en-IN') + '.';
          } else if (!inSize.length) {
            inBudget.forEach(function (p) {
              (p.sizes || []).forEach(function (x) { if (sizes.indexOf(x) < 0) sizes.push(x); });
            });
            msg = 'These only come in ' + sizes.join(', ') + ' at the moment' +
                  (picked.size ? ', not ' + picked.size[0] : '') + '. Ask us and we will check what else fits.';
          } else {
            msg = 'Nothing in stock matches that exact combination — ask us and we will find something.';
          }
          resultsGrid.innerHTML = '';
          resultsSub.textContent = msg;
          results.hidden = false;
          return;
        }

        var money = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };
        resultsSub.textContent = looks.length + ' look' + (looks.length > 1 ? 's' : '') +
          ' in stock' + (picked.size && picked.size[0].indexOf('Not sure') !== 0 ? ' in size ' + picked.size[0] : '') + '.';

        resultsGrid.innerHTML = looks.map(function (look) {
          var total = look.items.reduce(function (s2, p) { return s2 + p.p; }, 0);
          var why = [];
          look.items.forEach(function (p) { (p.why || []).forEach(function (w) { if (why.indexOf(w) < 0) why.push(w); }); });
          var shots = look.items.map(function (p) {
            return '<a class="smlook__shot" href="' + p.u + '"><img src="' + p.img + '" alt="' + p.t.replace(/"/g, '&quot;') + '" loading="lazy"></a>';
          }).join('');
          var names = look.items.map(function (p) {
            // Bottoms are sized by waist, so spell the options out rather than
            // leaving someone to guess whether their letter size applies.
            var sz = (!usesLetterSizes(p) && p.sizes && p.sizes.length)
              ? ' <i class="smlook__sz">' + p.sizes.join(' / ') + '</i>' : '';
            return '<a class="smlook__piece" href="' + p.u + '"><span>' + p.t + sz + '</span><em>' + money(p.p) + '</em></a>';
          }).join('');
          var chips = why.slice(0, 3).map(function (w) { return '<span class="smlook__why">' + w + '</span>'; }).join('');
          return '<article class="smlook">' +
                   '<div class="smlook__kind">' + look.kind + '</div>' +
                   '<div class="smlook__shots smlook__shots--' + look.items.length + '">' + shots + '</div>' +
                   '<div class="smlook__body">' + names +
                     (chips ? '<div class="smlook__whys">' + chips + '</div>' : '') +
                     '<div class="smlook__total"><span>Look total</span><strong>' + money(total) + '</strong></div>' +
                     '<a class="btn btn--line btn--sm smlook__cta" href="' + look.items[0].u + '">' +
                       (look.items.length > 1 ? 'Start with the top' : 'Shop this look') + '</a>' +
                   '</div>' +
                 '</article>';
        }).join('');
        results.hidden = false;
      }

      function render() {
        var c = compose();
        var ready = !!picked.occasion;
        if (preview) preview.textContent = c.line || 'Pick an occasion to start.';
        if (send) {
          send.setAttribute('href', ready ? 'https://wa.me/' + wa + '?text=' + encodeURIComponent(c.msg) : '#');
          send.setAttribute('aria-disabled', ready ? 'false' : 'true');
        }
        if (bodyField) bodyField.value = c.msg;
        recommend();
      }

      var waScroll = root.querySelector('[data-sm-scroll-wa]');
      if (waScroll && send) waScroll.addEventListener('click', function () {
        send.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      groups.forEach(function (group) {
        var key   = group.getAttribute('data-sm-group');
        var limit = parseInt(group.getAttribute('data-sm-multi'), 10) || 1;
        group.querySelectorAll('[data-sm-opt]').forEach(function (chip) {
          chip.addEventListener('click', function () {
            var val = chip.getAttribute('data-sm-opt');
            var cur = picked[key] || [];
            var at  = cur.indexOf(val);
            if (at > -1) {
              cur.splice(at, 1);                       // tapping again clears it
            } else {
              if (limit === 1) cur = [val];
              else { cur.push(val); if (cur.length > limit) cur.shift(); }
            }
            picked[key] = cur.length ? cur : null;
            group.querySelectorAll('[data-sm-opt]').forEach(function (c2) {
              c2.classList.toggle('is-on', !!picked[key] && picked[key].indexOf(c2.getAttribute('data-sm-opt')) > -1);
            });
            render();
          });
        });
      });

      if (note) note.addEventListener('input', render);
      if (send) send.addEventListener('click', function (e) {
        if (send.getAttribute('aria-disabled') === 'true') e.preventDefault();
      });
      if (emailBtn && emailForm) emailBtn.addEventListener('click', function () {
        emailForm.hidden = false;
        emailForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        render();
      });
      render();
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var items = [].slice.call(gallery.querySelectorAll('.pdp__gallery-item'));
      if (!items.length) return;
      var dots = [].slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
      var next = gallery.querySelector('[data-gallery-next]');
      var prev = gallery.querySelector('[data-gallery-prev]');
      var delay = parseInt(gallery.getAttribute('data-gallery-autoplay'), 10) || 4000;
      var index = 0;
      var timer = null;
      var paused = false;

      // The track height follows the active slide. 40 of 59 products mix aspect
      // ratios, so one fixed ratio always letterboxed something; this way every
      // image fills its frame and nothing is cropped. CSS transitions the change.
      var track = gallery.querySelector('.pdp__gallery-track');
      function syncRatio() {
        if (!track) return;
        var ar = parseFloat(items[index].getAttribute('data-ar'));
        if (ar > 0) track.style.setProperty('--pdp-ratio', ar);
      }
      function show(i) {
        items[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (i + items.length) % items.length;
        items[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
        syncRatio();
      }
      // Don't auto-advance past a video — let it play; resume once user moves on.
      function activeIsVideo() {
        return !!items[index].querySelector('video');
      }
      function tick() {
        if (!paused && !activeIsVideo()) show(index + 1);
      }
      function start() {
        if (items.length < 2 || timer) return;
        timer = setInterval(tick, delay);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      // A manual interaction restarts the countdown so it never jumps immediately after.
      function bump(i) { show(i); stop(); start(); }

      if (next) next.addEventListener('click', function () { bump(index + 1); });
      if (prev) prev.addEventListener('click', function () { bump(index - 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          bump(parseInt(dot.getAttribute('data-gallery-dot'), 10) || 0);
        });
      });

      gallery.addEventListener('mouseenter', function () { paused = true; });
      gallery.addEventListener('mouseleave', function () { paused = false; });
      gallery.addEventListener('focusin', function () { paused = true; });
      gallery.addEventListener('focusout', function () { paused = false; });
      // Pause auto-scroll while the tab is hidden (saves work, avoids surprise jumps).
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      gallery.showMediaId = function (id) {
        if (id == null) return;
        for (var i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-media-id') === String(id)) { bump(i); return; }
        }
      };
      start();
    });
  }

  /* ============================================================
     SORT DROPDOWN + FILTER DRAWER FACETS (UI only)
     ============================================================ */
  function initSortDropdown() {
    document.querySelectorAll('[data-sort-dropdown]').forEach(function (dd) {
      var trigger = dd.querySelector('[data-sort-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = dd.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(isOpen));
      });
      document.addEventListener('click', function (e) {
        if (!dd.contains(e.target)) { dd.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
      });
    });
  }

  function initFacets() {
    document.querySelectorAll('.facet-group__head').forEach(function (head) {
      head.addEventListener('click', function () {
        head.closest('.facet-group').classList.toggle('is-collapsed');
      });
    });
  }

  /* ============================================================
     CAROUSEL (related products)
     ============================================================ */
  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('.carousel-track');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;
      var step = function () {
        var card = track.querySelector('.product-card');
        return card ? card.getBoundingClientRect().width + 32 : 300;
      };
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    });
  }

  /* ============================================================
     VARIANT PICKER — supports 1..N options (Size only today; Size+Color
     once a product has real multi-color media, per PRD.md §5.4).
     Matches the full set of selected option values against the product's
     embedded variants JSON rather than mirroring a single data-variant-id,
     so it stays correct if a color axis is added later.
     ============================================================ */
  function initVariantPicker() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var wrapper = form.closest('[data-product-root]') || form;
      var variantsScript = wrapper.querySelector('[data-product-variants]');
      var variants = [];
      if (variantsScript) {
        try { variants = JSON.parse(variantsScript.textContent); } catch (err) { variants = []; }
      }
      var idInput = form.querySelector('[name="id"]');
      var priceEl = wrapper.querySelector('[data-price]');
      var galleryEl = wrapper.querySelector('[data-gallery]');
      var submitBtn = form.querySelector('[type="submit"]');
      var addLabel = form.hasAttribute('data-preorder') ? 'Pre-order Now' : 'Add to Cart';

      function currentSelection() {
        var groups = form.querySelectorAll('[data-option-index]');
        return [].map.call(groups, function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function syncVariant() {
        if (!variants.length) return;
        var selection = currentSelection();
        var match = variants.filter(function (v) {
          return v.options.every(function (opt, i) { return opt === selection[i]; });
        })[0];
        if (!match) {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (galleryEl && galleryEl.showMediaId && match.mediaId != null) galleryEl.showMediaId(match.mediaId);
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available ? addLabel : 'Sold Out';
        }
      }

      form.addEventListener('change', function (e) {
        if (e.target.closest('[data-option-index]')) syncVariant();
      });
      syncVariant();

      var qtyInput = form.querySelector('[data-qty-input]');
      form.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var val = parseInt(qtyInput.value, 10) || 1;
          val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(1, val - 1);
          qtyInput.value = val;
        });
      });
    });
  }

  /* ============================================================
     CART — AJAX add/update via Shopify's Cart API, drawer render
     ============================================================ */
  function moneyFormat(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  var ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) { return ESCAPE_MAP[ch]; });
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('#cart-drawer [data-cart-items]');
    var summary = document.querySelector('#cart-drawer [data-cart-summary]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (summary) summary.hidden = true;
      return;
    }
    if (summary) summary.hidden = false;
    body.innerHTML = cart.items.map(function (item) {
      return '' +
        '<div class="cart-line-item" data-line-key="' + escapeHtml(item.key) + '">' +
          '<div class="cart-line-item__media"><img src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></div>' +
          '<div>' +
            '<h3 class="cart-line-item__title">' + escapeHtml(item.product_title) + '</h3>' +
            '<p class="cart-line-item__meta">' + escapeHtml(item.variant_title || '') + '</p>' +
            (function () {
              var props = item.properties || {}, out = '';
              for (var k in props) {
                if (Object.prototype.hasOwnProperty.call(props, k) && k.charAt(0) !== '_' && props[k]) {
                  out += '<p class="cart-line-item__prop"><span>' + escapeHtml(k) + ':</span> ' + escapeHtml(props[k]) + '</p>';
                }
              }
              return out;
            })() +
            '<div class="cart-line-item__row">' +
              '<div class="qty-stepper">' +
                '<button type="button" data-cart-qty-minus aria-label="Decrease quantity">&minus;</button>' +
                '<input type="text" readonly value="' + item.quantity + '" aria-label="Quantity">' +
                '<button type="button" data-cart-qty-plus aria-label="Increase quantity">&plus;</button>' +
              '</div>' +
              '<span>' + moneyFormat(item.final_line_price) + '</span>' +
              '<button type="button" class="cart-line-item__remove" data-cart-remove>Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');
    var subtotalEl = document.querySelector('#cart-drawer [data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
    updateShipMeter(cart);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        openDrawerById('cart-drawer');
        return cart;
      })
      .catch(function (err) { console.error('[AUREAH] add to cart failed', err); });
  }

  function changeCartLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  /* Line-item properties: an untouched text input still posts `properties[…]=""`,
     and Shopify records the empty property on the order. So every order showed
     "Your size / measurements / request:" with nothing after it, which is
     indistinguishable from the form being broken — order #1016 was reported as
     exactly that. The cart drawer already skips empty props (see renderCartDrawer),
     so the cart and the order disagreed too.

     Blank now means one of two things rather than noise:
       · on a made-to-fit piece, the PDP already promises "we'll confirm the
         details on WhatsApp", so the property is set to say so — the merchant
         needs to know the order is waiting on measurements, not see a blank
       · anywhere else, the property is dropped entirely
     A filled field is trimmed and kept. So a label in the order now always
     carries meaning. */
  var MTF_PROP = 'properties[Your size / measurements / request]';
  function cleanLineItemProperties(form, formData) {
    var keys = [];
    formData.forEach(function (v, k) { keys.push(k); });
    keys.forEach(function (k) {
      if (k.indexOf('properties[') !== 0) return;
      var val = (formData.get(k) || '').trim();
      if (val) { formData.set(k, val); return; }
      if (k === MTF_PROP && form.querySelector('[data-mtf-input]')) {
        formData.set(k, 'To be confirmed on WhatsApp');
      } else {
        formData.delete(k);
      }
    });
    return formData;
  }

  function initCartForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      addToCart(cleanLineItemProperties(form, new FormData(form))).then(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
    });

    document.addEventListener('click', function (e) {
      var lineEl = e.target.closest('.cart-line-item');
      if (!lineEl) return;
      var key = lineEl.getAttribute('data-line-key');
      var qtyInput = lineEl.querySelector('.qty-stepper input');
      if (e.target.matches('[data-cart-qty-plus]')) {
        changeCartLine(key, (parseInt(qtyInput.value, 10) || 1) + 1);
      } else if (e.target.matches('[data-cart-qty-minus]')) {
        changeCartLine(key, Math.max(0, (parseInt(qtyInput.value, 10) || 1) - 1));
      } else if (e.target.matches('[data-cart-remove]')) {
        changeCartLine(key, 0);
      }
    });

    /* keep the header bubble + free-delivery meter in sync on load */
    fetchCart().then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      updateShipMeter(cart);
    }).catch(function () {});
  }

  /* ============================================================
     QUICK ADD — populate drawer from a card's embedded product JSON
     ============================================================ */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-add-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var card = trigger.closest('[data-product-card]');
      var script = card && card.querySelector('[data-product-json]');
      if (!script) return;
      var product;
      try { product = JSON.parse(script.textContent); } catch (err) { return; }

      var drawer = document.getElementById('quick-add-drawer');
      var body = drawer && drawer.querySelector('[data-quick-add-body]');
      if (!body) return;

      var sizes = product.variants.map(function (v) {
        return '<label class="option-value">' +
          '<input type="radio" name="quick-add-size" data-variant-id="' + escapeHtml(v.id) + '" ' + (v.available ? '' : 'disabled') + '>' +
          '<span class="option-value__pill">' + escapeHtml(v.title) + '</span>' +
          '</label>';
      }).join('');

      body.innerHTML = '' +
        '<div class="cart-line-item" style="border:0;">' +
          '<div class="cart-line-item__media"><img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '"></div>' +
          '<div>' +
            '<h3 class="cart-line-item__title">' + escapeHtml(product.title) + '</h3>' +
            '<p class="cart-line-item__meta">' + escapeHtml(product.price) + '</p>' +
          '</div>' +
        '</div>' +
        '<div class="option-group"><div class="option-values">' + sizes + '</div></div>' +
        '<button type="button" class="btn btn--primary btn--full" data-quick-add-submit disabled style="margin-top:22px;">Add to Cart</button>';

      var submitBtn = body.querySelector('[data-quick-add-submit]');
      body.querySelectorAll('input[data-variant-id]').forEach(function (input) {
        input.addEventListener('change', function () { submitBtn.disabled = false; });
      });
      submitBtn.addEventListener('click', function () {
        var checked = body.querySelector('input[data-variant-id]:checked');
        if (!checked) return;
        var fd = new FormData();
        fd.append('id', checked.getAttribute('data-variant-id'));
        fd.append('quantity', 1);
        addToCart(fd);
      });

      openDrawerById('quick-add-drawer', trigger);
    });
  }

  /* ---- share popover (PDP) + copy link ----
     Explicit network links do the sharing; Copy Link uses async clipboard
     with an execCommand fallback so it works everywhere, with "Copied"
     feedback either way. */
  function initShare() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-share-toggle]');
      if (toggle) {
        var pop = toggle.closest('[data-share]').querySelector('[data-share-pop]');
        var open = pop.hidden;
        pop.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        return;
      }
      var wrap = e.target.closest('[data-share]');
      if (!wrap) {
        document.querySelectorAll('[data-share-pop]').forEach(function (pop) {
          if (!pop.hidden) {
            pop.hidden = true;
            var t = pop.closest('[data-share]').querySelector('[data-share-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  }

  function initCopyLink() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy-link]');
      if (!btn) return;
      var url = btn.getAttribute('data-copy-link');
      var label = btn.querySelector('span') || btn;
      var original = btn.getAttribute('data-label') || label.textContent;
      btn.setAttribute('data-label', original);
      var done = function () { label.textContent = 'Copied'; setTimeout(function () { label.textContent = original; }, 1800); };
      var legacyCopy = function () {
        var input = document.createElement('input');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        document.body.removeChild(input);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(legacyCopy);
      } else {
        legacyCopy();
      }
    });
  }

  /* ============================================================
     PREDICTIVE SEARCH — Shopify's /search/suggest.json, debounced 300ms
     ============================================================ */
  function initPredictiveSearch() {
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-suggestions]');
    if (!input || !results) return;
    var timer = null;
    var lastQuery = '';

    function render(products) {
      products = products.filter(function (p) { return (p.url || '').indexOf('/products/owner-test-1') === -1; });
      if (!products.length) {
        results.innerHTML = '<p class="search-suggest__empty">No matches — press Enter to search everything.</p>';
        results.hidden = false;
        return;
      }
      results.innerHTML = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + escapeHtml(p.featured_image.url) + '&width=120" alt="" loading="lazy">'
          : '';
        var price = '₹' + (parseFloat(p.price) || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });
        return '<a class="search-suggest__item" href="' + escapeHtml(p.url) + '">' +
          '<span class="search-suggest__media">' + img + '</span>' +
          '<span><span class="search-suggest__title">' + escapeHtml(p.title) + '</span>' +
          '<span class="search-suggest__price">' + price + '</span></span>' +
          '</a>';
      }).join('');
      results.hidden = false;
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; lastQuery = ''; return; }
      timer = setTimeout(function () {
        if (q === lastQuery) return;
        lastQuery = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (input.value.trim() === q) render(products);
          })
          .catch(function () {});
      }, 300);
    });

    document.addEventListener('click', function (e) {
      if (!results.contains(e.target) && e.target !== input) results.hidden = true;
    });
    input.addEventListener('focus', function () {
      if (results.innerHTML && input.value.trim().length >= 2) results.hidden = false;
    });
  }

  /* ============================================================
     RECENTLY VIEWED — recorded on each PDP visit, shown on the search page
     ============================================================ */
  var RV_KEY = 'aureah:recently-viewed';

  function initRecentlyViewedRecorder() {
    var script = document.querySelector('[data-rv-product]');
    if (!script) return;
    var product;
    try { product = JSON.parse(script.textContent); } catch (err) { return; }
    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (err) { list = []; }
    list = list.filter(function (p) { return p.url !== product.url; });
    list.unshift(product);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8))); } catch (err) {}
  }

  function initRecentlyViewedList() {
    var wrap = document.querySelector('[data-recently-viewed]');
    if (!wrap) return;
    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (err) { list = []; }
    if (!list.length) return;
    var target = wrap.querySelector('[data-recently-viewed-list]');
    if (!target) return;
    target.innerHTML = list.map(function (p) {
      return '<a class="search-suggest__item" href="' + escapeHtml(p.url) + '">' +
        '<span class="search-suggest__media">' + (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span><span class="search-suggest__title">' + escapeHtml(p.title) + '</span>' +
        '<span class="search-suggest__price">' + escapeHtml(p.price) + '</span></span>' +
        '</a>';
    }).join('');
    wrap.hidden = false;
  }

  /* ---- login/recover panel toggle (templates/customers/login.json) ---- */
  function initAuthPanels() {
    var page = document.querySelector('[data-login-page]');
    if (!page) return;
    var loginPanel = page.querySelector('[data-panel="login"]');
    var recoverPanel = page.querySelector('[data-panel="recover"]');
    function sync() {
      var showRecover = window.location.hash === '#recover' || recoverPanel.querySelector('.form-errors, .form-success');
      loginPanel.hidden = !!showRecover;
      recoverPanel.hidden = !showRecover;
    }
    page.addEventListener('click', function (e) {
      if (e.target.closest('[data-show-recover]')) { window.location.hash = 'recover'; sync(); }
      if (e.target.closest('[data-show-login]')) { window.location.hash = ''; sync(); }
    });
    window.addEventListener('hashchange', sync);
    sync();
  }

  /* ============================================================
     NOTIFY-SERVICE — fire-and-forget auto-reply trigger for the newsletter
     and contact forms (see PRD.md §6 and notify-service/README.md). Never
     blocks or interferes with Shopify's own native form submission: this
     listener does not call preventDefault, and any fetch failure is
     swallowed silently so the native submission is the only thing the
     visitor's experience depends on.
     ============================================================ */
  function initNotifyForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-notify-form]');
      if (!form) return;
      var url = form.getAttribute('data-notify-url');
      if (!url) return;
      var type = form.getAttribute('data-notify-form');
      var payload = { type: type };
      if (type === 'newsletter') {
        var emailInput = form.querySelector('input[name="contact[email]"]');
        if (!emailInput || !emailInput.value) return;
        payload.email = emailInput.value;
      } else if (type === 'contact') {
        payload.name = (form.querySelector('input[name="contact[name]"]') || {}).value || '';
        payload.email = (form.querySelector('input[name="contact[email]"]') || {}).value || '';
        payload.message = (form.querySelector('textarea[name="contact[body]"]') || {}).value || '';
      }
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    });
  }

  /* ---- announcement bar: rotate multiple messages, pause-free, fade ---- */
  function initAnnounce() {
    var bar = document.querySelector('[data-announce]');
    if (!bar) return;
    var msgs = [].slice.call(bar.querySelectorAll('.announce-bar__msg'));
    if (msgs.length < 2) return;

    var i = 0, timer = null;
    function show(n) {
      msgs[i].classList.remove('is-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    function start() {
      // Reduced-motion still gets the arrows, just no automatic rotation.
      if (reduce || timer) return;
      timer = setInterval(function () { show(i + 1); }, 4500);
    }
    function stop() { clearInterval(timer); timer = null; }
    function step(n) { show(n); stop(); start(); }

    var prev = bar.querySelector('[data-announce-prev]');
    var next = bar.querySelector('[data-announce-next]');
    if (prev) prev.addEventListener('click', function () { step(i - 1); });
    if (next) next.addEventListener('click', function () { step(i + 1); });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);

    // Swipe the bar on touch, same axis-lock approach as the hero.
    var sx = 0, sy = 0, axis = null, done = false;
    bar.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; axis = null; done = false;
      stop();
    }, { passive: true });
    bar.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1 || done) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (axis === 'x' && Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); done = true; }
    }, { passive: true });
    bar.addEventListener('touchend', function () { setTimeout(start, 900); });

    start();
  }

  /* ---- nav drawer: collapsible "Collections" group ---- */
  function initNavGroups() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-nav-group-toggle]');
      if (!toggle) return;
      var group = toggle.closest('[data-nav-group]');
      var open = group.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ============================================================
     FREE-DELIVERY METER + COUPON — cart drawer & /cart page.
     The meter reads its paise threshold from data-threshold and, once the
     subtotal crosses it, auto-applies FREEDELIVERY via the /discount/
     endpoint (sets Shopify's checkout discount cookie). Coupon apply uses
     the same endpoint — Shopify validates the code at checkout; removal
     expires the (non-httpOnly) discount_code cookie.
     ============================================================ */
  var COUPON_KEY = 'aureah:coupon';
  var FREEDEL_CODE = 'FREEDELIVERY';

  function applyDiscountCode(code) {
    return fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
  }

  function updateShipMeter(cart) {
    var meters = [].slice.call(document.querySelectorAll('[data-ship-meter]'));
    if (!meters.length || !cart) return;
    meters.forEach(function (meter) {
      var threshold = parseInt(meter.getAttribute('data-threshold'), 10) || 0;
      var label = meter.querySelector('[data-ship-meter-label]');
      var bar = meter.querySelector('[data-ship-meter-bar]');
      if (!threshold || !label || !bar) return;
      var total = cart.total_price || 0;
      var pct = Math.min(100, Math.round(total / threshold * 100));
      bar.style.width = pct + '%';
      meter.classList.toggle('ship-meter--done', total >= threshold);
      if (total >= threshold) {
        label.textContent = 'Free delivery unlocked — ' + FREEDEL_CODE + ' applies at checkout';
      } else {
        label.textContent = moneyFormat(threshold - total) + ' away from free delivery';
      }
    });
    if (cart.total_price >= (parseInt(meters[0].getAttribute('data-threshold'), 10) || Infinity)) {
      applyDiscountCode(FREEDEL_CODE);
    }
  }

  function initCoupon() {
    var roots = [].slice.call(document.querySelectorAll('[data-coupon]'));
    if (!roots.length) return;

    function render(root) {
      var saved = '';
      try { saved = localStorage.getItem(COUPON_KEY) || ''; } catch (err) {}
      var toggle = root.querySelector('[data-coupon-toggle]');
      var row = root.querySelector('[data-coupon-row]');
      var applied = root.querySelector('[data-coupon-applied]');
      var codeLabel = root.querySelector('[data-coupon-code-label]');
      if (saved) {
        if (toggle) toggle.hidden = true;
        if (row) row.hidden = true;
        if (applied) applied.hidden = false;
        if (codeLabel) codeLabel.textContent = saved;
      } else {
        if (toggle) { toggle.hidden = false; toggle.setAttribute('aria-expanded', 'false'); }
        if (row) row.hidden = true;
        if (applied) applied.hidden = true;
      }
    }

    roots.forEach(function (root) {
      var toggle = root.querySelector('[data-coupon-toggle]');
      var row = root.querySelector('[data-coupon-row]');
      var input = root.querySelector('[data-coupon-input]');
      var msg = root.querySelector('[data-coupon-msg]');

      function say(text) {
        if (!msg) return;
        msg.hidden = !text;
        msg.textContent = text || '';
      }

      if (toggle) toggle.addEventListener('click', function () {
        row.hidden = !row.hidden;
        toggle.setAttribute('aria-expanded', String(!row.hidden));
        if (!row.hidden && input) input.focus();
      });

      function apply() {
        var code = (input && input.value || '').trim().toUpperCase();
        if (!code) return;
        applyDiscountCode(code).then(function () {
          try { localStorage.setItem(COUPON_KEY, code); } catch (err) {}
          roots.forEach(render);
          say('Applied — your discount is reflected at checkout.');
        });
      }
      var applyBtn = root.querySelector('[data-coupon-apply]');
      if (applyBtn) applyBtn.addEventListener('click', apply);
      if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });

      var removeBtn = root.querySelector('[data-coupon-remove]');
      if (removeBtn) removeBtn.addEventListener('click', function () {
        try { localStorage.removeItem(COUPON_KEY); } catch (err) {}
        document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        roots.forEach(render);
        say('');
      });

      render(root);
    });
  }

  /* ============================================================
     WISHLIST — localStorage-backed, no app, works for guests.
     Hearts live on product cards ([data-wishlist-toggle], keyed by the
     card's embedded product JSON url); /pages/wishlist renders the list.
     ============================================================ */
  var WL_KEY = 'aureah:wishlist';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (err) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (err) {}
  }
  function syncWishlistCounts() {
    var n = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function pdpWishlistProduct() {
    var script = document.querySelector('[data-rv-product]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (err) { return null; }
  }

  function markWishlistHearts() {
    var saved = readWishlist().map(function (p) { return p.url; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var card = btn.closest('[data-product-card]');
      var script = card && card.querySelector('[data-product-json]');
      if (!script) return;
      var product;
      try { product = JSON.parse(script.textContent); } catch (err) { return; }
      var on = saved.indexOf(product.url) !== -1;
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', String(on));
    });
    var pdpBtn = document.querySelector('[data-wishlist-toggle-pdp]');
    var pdpProduct = pdpBtn && pdpWishlistProduct();
    if (pdpBtn && pdpProduct) {
      var pdpOn = saved.indexOf(pdpProduct.url) !== -1;
      pdpBtn.classList.toggle('is-saved', pdpOn);
      pdpBtn.setAttribute('aria-pressed', String(pdpOn));
      var label = pdpBtn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = pdpOn ? 'Saved to Wishlist' : 'Save to Wishlist';
    }
  }

  function toggleWishlistItem(product) {
    var list = readWishlist();
    var exists = list.some(function (p) { return p.url === product.url; });
    if (exists) {
      list = list.filter(function (p) { return p.url !== product.url; });
    } else {
      list.unshift({ url: product.url, title: product.title, image: product.image, price: product.price });
    }
    writeWishlist(list);
    markWishlistHearts();
    syncWishlistCounts();
    renderWishlistPage();
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    var list = readWishlist();
    if (!list.length) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    grid.hidden = false;
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (p) {
      return '<div class="wishlist-tile">' +
        '<a class="cat-tile" href="' + escapeHtml(p.url) + '">' +
          '<span class="cat-tile__media">' + (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</span>' +
          '<span class="cat-tile__title serif">' + escapeHtml(p.title) + '</span>' +
          '<span class="cat-tile__price">' + escapeHtml(p.price) + '</span>' +
        '</a>' +
        '<button type="button" class="wishlist-tile__remove" data-wishlist-remove="' + escapeHtml(p.url) + '">Remove</button>' +
      '</div>';
    }).join('');
  }

  function initWishlist() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        var card = toggle.closest('[data-product-card]');
        var script = card && card.querySelector('[data-product-json]');
        if (!script) return;
        var product;
        try { product = JSON.parse(script.textContent); } catch (err) { return; }
        toggleWishlistItem(product);
        return;
      }
      var pdpToggle = e.target.closest('[data-wishlist-toggle-pdp]');
      if (pdpToggle) {
        var pdpProduct = pdpWishlistProduct();
        if (pdpProduct) toggleWishlistItem(pdpProduct);
        return;
      }
      var remove = e.target.closest('[data-wishlist-remove]');
      if (remove) {
        var url = remove.getAttribute('data-wishlist-remove');
        writeWishlist(readWishlist().filter(function (p) { return p.url !== url; }));
        markWishlistHearts();
        syncWishlistCounts();
        renderWishlistPage();
      }
    });
    markWishlistHearts();
    syncWishlistCounts();
    renderWishlistPage();
  }

  /* ============================================================
     CATEGORY EXPLORER — hover-open rows on pointer devices, tap-to-open
     on touch. Coming-soon rows use a <button> head (toggle only); live
     rows use an <a> head — hover previews, click navigates on desktop,
     first tap previews / second tap navigates on touch.
     ============================================================ */
  function initCategoryExplorer() {
    var index = document.querySelector('[data-cat-index]');
    if (!index) return;
    var rows = [].slice.call(index.querySelectorAll('[data-cat-row]'));
    var hoverable = window.matchMedia('(hover: hover)').matches;

    function setOpen(row, on) {
      row.classList.toggle('is-open', on);
      var head = row.querySelector('[data-cat-head]');
      if (head) head.setAttribute('aria-expanded', String(on));
    }
    function openOnly(row) {
      rows.forEach(function (r) { setOpen(r, r === row); });
    }

    rows.forEach(function (row) {
      var head = row.querySelector('[data-cat-head]');
      if (!head) return;
      if (hoverable) {
        row.addEventListener('mouseenter', function () { openOnly(row); });
        row.addEventListener('mouseleave', function () { setOpen(row, false); });
        row.addEventListener('focusin', function () { openOnly(row); });
      }
      head.addEventListener('click', function (e) {
        var isOpen = row.classList.contains('is-open');
        if (head.tagName === 'BUTTON') {
          if (isOpen) setOpen(row, false); else openOnly(row);
          return;
        }
        if (!hoverable && !isOpen) { e.preventDefault(); openOnly(row); }
      });
    });
  }

  /* ============================================================
     STYLING ROOM — mix-and-match look builder (sections/styling-room.liquid).
     Cycles each slot's pieces, keeps a live total, adds every selected
     piece to the cart in one Cart API call, and mirrors the selection
     into the URL (?look=0.2.1) so a look can be shared/restored.
     ============================================================ */
  function initStylingRoom() {
    var root = document.querySelector('[data-styling-room]');
    if (!root) return;
    var slots = [].slice.call(root.querySelectorAll('[data-slot]')).map(function (el) {
      var items = [];
      var script = el.querySelector('[data-slot-data]');
      if (script) { try { items = JSON.parse(script.textContent); } catch (err) { items = []; } }
      return {
        el: el,
        items: items,
        index: 0,
        img: el.querySelector('[data-slot-img]'),
        name: el.querySelector('[data-slot-name]'),
        price: el.querySelector('[data-slot-price]')
      };
    }).filter(function (s) { return s.items.length; });
    if (!slots.length) return;

    var list = root.querySelector('[data-look-list]');
    var totalEl = root.querySelector('[data-look-total]');

    function renderSlot(s) {
      var item = s.items[s.index];
      if (s.img) { s.img.src = item.image; s.img.alt = item.title; }
      if (s.name) { s.name.textContent = item.title; s.name.href = item.url; }
      if (s.price) s.price.textContent = item.price;
    }
    function renderSummary() {
      var total = 0;
      var rows = slots.map(function (s) {
        var item = s.items[s.index];
        total += item.priceCents;
        return '<li><span>' + escapeHtml(item.title) + '</span><span>' + escapeHtml(item.price) + '</span></li>';
      });
      if (list) list.innerHTML = rows.join('');
      if (totalEl) totalEl.textContent = moneyFormat(total);
    }
    function renderAll() { slots.forEach(renderSlot); renderSummary(); }
    function syncUrl() {
      if (!window.history || !window.history.replaceState || !window.URL) return;
      var url = new URL(window.location.href);
      url.searchParams.set('look', slots.map(function (s) { return s.index; }).join('.'));
      window.history.replaceState(null, '', url.toString());
    }

    slots.forEach(function (s) {
      function step(delta) {
        s.index = (s.index + delta + s.items.length) % s.items.length;
        renderSlot(s); renderSummary(); syncUrl();
      }
      var prev = s.el.querySelector('[data-slot-prev]');
      var next = s.el.querySelector('[data-slot-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });

    var addBtn = root.querySelector('[data-look-add]');
    if (addBtn) addBtn.addEventListener('click', function () {
      addBtn.disabled = true;
      var items = slots.map(function (s) { return { id: s.items[s.index].variantId, quantity: 1 }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(fetchCart)
        .then(function (cart) { renderCartDrawer(cart); openDrawerById('cart-drawer', addBtn); })
        .catch(function (err) { console.error('[AUREAH] add look failed', err); })
        .then(function () { addBtn.disabled = false; });
    });

    var shuffleBtn = root.querySelector('[data-look-shuffle]');
    if (shuffleBtn) shuffleBtn.addEventListener('click', function () {
      slots.forEach(function (s) { s.index = Math.floor(Math.random() * s.items.length); });
      renderAll(); syncUrl();
    });

    var shareBtn = root.querySelector('[data-look-share]');
    if (shareBtn) shareBtn.addEventListener('click', function () {
      syncUrl();
      var label = shareBtn.querySelector('span') || shareBtn;
      var original = label.textContent;
      var done = function () { label.textContent = 'Link Copied'; setTimeout(function () { label.textContent = original; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(window.location.href).then(done).catch(function () {});
      } else { done(); }
    });

    var param = new URLSearchParams(window.location.search).get('look');
    if (param) param.split('.').forEach(function (v, i) {
      var n = parseInt(v, 10);
      if (slots[i] && n >= 0 && n < slots[i].items.length) slots[i].index = n;
    });
    renderAll();
  }

  /* ============================================================
     PRODUCT CARD — swipeable image rail
     Scrolling itself is native; this only keeps the dots in sync and stops a
     swipe from being read as a tap on the card's link.
     ============================================================ */
  function initCardGalleries() {
    var galleries = document.querySelectorAll('[data-card-gallery]');
    if (!galleries.length) return;

    Array.prototype.forEach.call(galleries, function (gallery) {
      var track = gallery.querySelector('.product-card__track');
      var dots = gallery.querySelectorAll('.product-card__dot');
      if (!track || !dots.length) return;

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === i);
        });
      }, { passive: true });

      // A horizontal drag should flip the image, not open the product. The
      // link is only suppressed once the finger has actually travelled.
      var startX = 0, moved = false;
      track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        moved = false;
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        if (Math.abs(e.touches[0].clientX - startX) > 10) moved = true;
      }, { passive: true });
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      });
    });
  }

  /* ============================================================
     APP SHELL — prefetch on intent
     "Feels instant" is mostly just having the next page already in cache by the
     time the tap lands. Fires on hover (desktop) and touchstart (mobile), which
     buys 100-300ms before the click event even resolves.
     ============================================================ */
  function initPrefetch() {
    if (!document.createElement('link').relList.supports('prefetch')) return;
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

    var seen = {};
    function prefetch(url) {
      if (seen[url]) return;
      seen[url] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      document.head.appendChild(link);
    }
    function onIntent(e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      if (href.charAt(0) !== '/' || href.charAt(1) === '/') return;
      if (href.indexOf('/cart') === 0 || href.indexOf('/account') === 0 || href.indexOf('#') === 0) return;
      if (href.split('#')[0] === location.pathname) return;
      prefetch(href);
    }
    document.addEventListener('pointerenter', onIntent, { capture: true, passive: true });
    document.addEventListener('touchstart', onIntent, { capture: true, passive: true });
  }

  /* ============================================================
     APP SHELL — drag-to-dismiss bottom sheets
     Only on touch, and only below the desktop breakpoint where .drawer--sheet
     is actually a bottom sheet — above it the panel is a side drawer and a
     vertical drag would mean nothing.
     ============================================================ */
  function initSheets() {
    var sheets = document.querySelectorAll('.drawer--sheet');
    if (!sheets.length) return;

    Array.prototype.forEach.call(sheets, function (sheet) {
      var panel = sheet.querySelector('.drawer__panel');
      if (!panel) return;
      var startY = 0, currentY = 0, dragging = false;

      function pointFrom(e) { return e.touches ? e.touches[0].clientY : e.clientY; }

      function start(e) {
        if (window.matchMedia('(min-width: 901px)').matches) return;
        var fromGrabber = e.target.closest('[data-sheet-grab], .drawer__head');
        var body = sheet.querySelector('.drawer__body');
        // Allow dragging from the body only when it is already scrolled to the top,
        // otherwise the gesture belongs to the scroll container, not the sheet.
        if (!fromGrabber && (!body || body.scrollTop > 0)) return;
        startY = pointFrom(e);
        currentY = 0;
        dragging = true;
        panel.classList.add('is-dragging');
      }

      function move(e) {
        if (!dragging) return;
        currentY = pointFrom(e) - startY;
        if (currentY < 0) currentY = 0;
        panel.style.transform = 'translateY(' + currentY + 'px)';
      }

      function end() {
        if (!dragging) return;
        dragging = false;
        panel.classList.remove('is-dragging');
        panel.style.transform = '';
        if (currentY > panel.offsetHeight * 0.3 || currentY > 160) {
          var closer = sheet.querySelector('[data-drawer-close]');
          if (closer) closer.click();
        }
      }

      panel.addEventListener('touchstart', start, { passive: true });
      panel.addEventListener('touchmove', move, { passive: true });
      panel.addEventListener('touchend', end);
      panel.addEventListener('touchcancel', end);
    });
  }

  /* ============================================================
     OCCASION HERO — slow horizontal carousel
     The copy and chips stay put; only the image bed moves. Pauses while the tab
     is hidden, on hover, and on touch, so it never yanks a slide out from under
     someone mid-tap. Honours prefers-reduced-motion by not auto-advancing.
     ============================================================ */
  function initOccasionHero() {
    var hero = document.querySelector('[data-ohero]');
    if (!hero) return;
    var track = hero.querySelector('[data-ohero-track]');
    var slides = hero.querySelectorAll('[data-ohero-slide]');
    if (!track || slides.length < 2) return;

    var dotsWrap = hero.querySelector('[data-ohero-dots]');
    var shopLink = hero.querySelector('[data-ohero-shop]');
    var shopName = hero.querySelector('[data-ohero-shop-name]');
    var eyebrowEl = hero.querySelector('[data-ohero-eyebrow]');
    var captionEl = hero.querySelector('[data-ohero-caption]');
    var prevBtn = hero.querySelector('[data-ohero-prev]');
    var nextBtn = hero.querySelector('[data-ohero-next]');
    var interval = parseInt(hero.getAttribute('data-ohero-interval'), 10) || 6000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0, timer = null, paused = false, copyTimer = null;

    // Section defaults, kept so a slide without its own copy restores them
    // rather than inheriting whatever the previous slide set.
    var baseEyebrow = eyebrowEl ? eyebrowEl.textContent : '';
    var baseCaption = captionEl ? captionEl.textContent : '';

    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < slides.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ohero__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', slides[i].getAttribute('data-title') || 'Look ' + (i + 1));
        (function (n) {
          dot.addEventListener('click', function () { go(n); restart(); });
        })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function go(n) {
      index = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (index * -100) + '%)';
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === index);
        if (dots[i]) dots[i].classList.toggle('is-active', i === index);
      }
      var current = slides[index];
      if (shopLink && shopName) {
        shopLink.href = current.getAttribute('data-url') || '#';
        shopName.textContent = current.getAttribute('data-title') || '';
      }
      // Swap the panel copy at the midpoint of the image slide and fade it
      // through the change — updating it immediately left the previous image
      // sitting under the next slide's headline for the whole transition.
      var nextEyebrow = current.getAttribute('data-eyebrow') || baseEyebrow;
      var nextCaption = current.getAttribute('data-caption') || baseCaption;
      var changed = (eyebrowEl && eyebrowEl.textContent !== nextEyebrow) ||
                    (captionEl && captionEl.textContent !== nextCaption);
      if (changed) {
        if (eyebrowEl) eyebrowEl.classList.add('is-swapping');
        if (captionEl) captionEl.classList.add('is-swapping');
        clearTimeout(copyTimer);
        copyTimer = setTimeout(function () {
          if (eyebrowEl) { eyebrowEl.textContent = nextEyebrow; eyebrowEl.classList.remove('is-swapping'); }
          if (captionEl) { captionEl.textContent = nextCaption; captionEl.classList.remove('is-swapping'); }
        }, 420);
      }
      // Drives the panel's shape: full-bleed, editorial split, or stand-aside
      // for a promo creative that carries its own copy.
      hero.setAttribute('data-active-layout', current.getAttribute('data-layout') || 'full');
    }

    function tick() { if (!paused && !document.hidden) go(index + 1); }
    function start() { if (reduce || timer) return; timer = setInterval(tick, interval); }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); start(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); restart(); });

    hero.addEventListener('mouseenter', function () { paused = true; });
    hero.addEventListener('mouseleave', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    /* Swipe. The gesture's axis is decided once, from the first few pixels of
       movement, and never revisited for that touch — so a mostly-vertical drag
       scrolls the page and never nudges the carousel sideways, which is what
       makes a hero feel like it's shaking under the thumb. */
    var sx = 0, sy = 0, axis = null, swiped = false;

    hero.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      axis = null;
      swiped = false;
      paused = true;
    }, { passive: true });

    hero.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1 || swiped) return;
      var dx = e.touches[0].clientX - sx;
      var dy = e.touches[0].clientY - sy;
      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (axis !== 'x') return;
      if (Math.abs(dx) > 45) {
        go(dx < 0 ? index + 1 : index - 1);
        swiped = true;
        restart();
      }
    }, { passive: true });

    hero.addEventListener('touchend', function () {
      // Resume a beat later so a slide never moves under a tap in progress.
      setTimeout(function () { paused = false; }, 1200);
    });

    go(0);
    start();
  }

  /* ============================================================
     FOOTER — collapse the link columns on mobile
     The markup ships with `open` so desktop renders plain lists even without
     JS; below the breakpoint the attribute is removed so the columns become
     real accordions. Ten stacked links made the footer taller than most of the
     pages above it.
     ============================================================ */
  function initFooterCols() {
    var cols = document.querySelectorAll('.footer-col');
    if (!cols.length) return;
    var mq = window.matchMedia('(max-width: 900px)');
    var touched = false;

    function apply() {
      Array.prototype.forEach.call(cols, function (col) {
        if (mq.matches) {
          // Don't fight the visitor once they've opened one themselves.
          if (!touched) col.removeAttribute('open');
        } else {
          col.setAttribute('open', '');
        }
      });
    }

    Array.prototype.forEach.call(cols, function (col) {
      col.addEventListener('toggle', function () { if (mq.matches) touched = true; });
    });

    apply();
    if (mq.addEventListener) mq.addEventListener('change', function () { touched = false; apply(); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initNav();
    initAnnounce();
    initNavGroups();
    initCoupon();
    initWishlist();
    initCountdowns();
    initReveal();
    initDrawers();
    initProductCardVideo();
    initAccordion();
    initHeroSlideshow();
    initHeroProduct();
    initTileCarousels();
    initGallery();
    initStyleMe();
    initShipBar();
    initStickyAtc();
    initNewsletterPopup();
    initCopyCode();
    initSortDropdown();
    initFacets();
    initCarousel();
    initVariantPicker();
    initCartForms();
    initQuickAdd();
    initShare();
    initCopyLink();
    initAuthPanels();
    initCategoryExplorer();
    initStylingRoom();
    initNotifyForms();
    initPredictiveSearch();
    initRecentlyViewedRecorder();
    initRecentlyViewedList();
    initPrefetch();
    initSheets();
    initFooterCols();
    initOccasionHero();
    initCardGalleries();
  });
})();
